// extracted by mini-css-extract-plugin
export default {"row":"YearPlanTableItem_row__yvpNP","labels":"YearPlanTableItem_labels__4uXn3","icons":"YearPlanTableItem_icons__G457c","freezeSubject":"YearPlanTableItem_freezeSubject__1ecJO"};